<template>
  <page-outline :title="changePassword_title"
    iconFA="gear">

    <template slot="pageContent">
      <b-row class="justify-content-start">
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.idtfr')" :inputValue="login">
          </form-read-group-label-input>
        </b-col>
        <b-col v-if="!connectToGoogle" sm="6" class="form-group">
          <form-write-group-label-input v-model="originalPassword" isMandatory
            :inputLabel="$t('common.orig_pwd')" :placeholderValue="changePassword_OriginalPassword"
            inputType="password">
          </form-write-group-label-input>
        </b-col>
        <b-col v-if="connectToGoogle" sm="6" class="form-group">
          <form-write-group-label-input v-model="newPassword" isMandatory
            :inputLabel="$t('common.pwd')" :placeholderValue="changePassword_Password"
            inputType="password">
          </form-write-group-label-input>
        </b-col>
        <b-col v-if="!connectToGoogle" sm="6" class="form-group">
          <form-write-group-label-input v-model="newPassword" isMandatory
            :inputLabel="$t('common.new_pwd')" :placeholderValue="changePassword_NewPassword"
            inputType="password">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="confirmNewPassword" isMandatory
            :inputLabel="$t('common.conf_pwd')" :placeholderValue="changePassword_ConfirmPassword"
            inputType="password">
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <b-row v-if="connectToGoogle" class="form-group">
        <div class="text-right col-sm-12 small font-italic">{{ $t('profilesPage.ggl_check_pwd') }}</div>
      </b-row>
    </template>

    <template slot="footerButtons">
      <b-row class="form-group justify-content-center">
        <b-col md="5" xl="3" offset-xl="7">
          <f7-button
            :title="changePassword_Validatechanges"
            class="button-action milkyBlockBlack"
            @click="changePassword">
            <f7-icon fa="icon fa fa-save"></f7-icon>
            <span>{{ $t('common.sve') }}</span>
          </f7-button>
        </b-col>
      </b-row>
      <div class="toolbarPageBottomBlank"></div>
    </template>
  </page-outline>
</template>

<script>
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      login: '',
      originalPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      connectToGoogle: false
    }
  },
  created () {
    this.changePassword_title = this.$i18n.t('common.chg_pwd')
    this.changePassword_OriginalPassword = this.$i18n.t('common.orig_pwd')
    this.changePassword_Password = this.$i18n.t('common.pwd')
    this.changePassword_NewPassword = this.$i18n.t('common.new_pwd')
    this.changePassword_ConfirmPassword = this.$i18n.t('common.conf_pwd')
    this.changePassword_Validatechanges = this.$i18n.t('common.valid_chgs')
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.login = this.$engine.user.get().identifier
  },
  mounted () {
    console.log(this.$engine.user.connectBy)
    if (this.$engine.user.connectBy === 'vue-google-oauth2') {
      this.connectToGoogle = true
    } else {
      this.connectToGoogle = false
    }
  },
  methods: {
    changePasswordAPI (connectBy) {
      let that = this
      this.$engine.user.changePassword({
        originalPassword: this.originalPassword,
        newPassword: this.newPassword,
        'connectBy': connectBy
      })
      .then(response => {
        if (response.status === 200) {
          this.$engine.user.connectBy = 'login-password-capi'
          that.$f7.modal({
            title: 'Password modified',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/profile/', force: false, ignoreCache: false})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    changePassword () {
      let that = this
      if (that.newPassword !== that.confirmNewPassword) {
        that.$f7.alert('Passwords do not match', 'Error')
      } else if (that.originalPassword === '' && this.$engine.user.connectBy !== 'vue-google-oauth2') {
        that.$f7.alert('Original password missing', 'Error')
      } else if (that.newPassword === '') {
        that.$f7.alert('New password missing', 'Error')
      } else if (that.confirmNewPassword === '') {
        that.$f7.alert('Please confirm password', 'Error')
      } else {
        var connectBy = 'lpc'
        if (this.$engine.user.connectBy === 'vue-google-oauth2') {
          connectBy = 'vgo'
          // On se conecte via Google
          this.$gAuth.signIn()
          .then(GoogleUser => {
            this.changePasswordAPI(connectBy)
          })
          .catch(error => {
            errorMessageAlert(error, this)
          })
        } else {
          this.changePasswordAPI(connectBy)
        }
      }
    }
  }
}
</script>
<style scoped>
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}
</style>



// WEBPACK FOOTER //
// CMChangePassword.vue?6c4c82a9